import React from 'react';
import Image from 'next/image';
import editNext from '../../svgs/pen_edit_icon.svg';
import { NextImageProps } from '../NextImageProps';

export function EditNext({ className, width, height, alt }: NextImageProps) {
  return (
    <Image
      width={width}
      height={height}
      className={className}
      src={editNext}
      alt={alt ?? 'Redigere'}
    />
  );
}
